// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React from "react";

import { FedExPickUpAddress } from "./FedExTypes";

export interface AddressProps {
  address: FedExPickUpAddress;
  className?: string;
}

export const Address = ({ address, className }: AddressProps) => {
  return (
    <div className={className}>
      {address.line.map((line, idx) => (
        <div key={idx}>{line}</div>
      ))}
      <div>
        {address.city}, {address.state} {address.postalCode}
      </div>
    </div>
  );
};
